import { Action } from '@ngrx/store';
import {DeviceMonitoringFilter} from '../../../models/devices';

export enum DeviceMonitoringFilterActionTypes {
  LoadDeviceMonitoringFilters = '[DeviceMonitoringFilter] Load DeviceMonitoringFilters',
  SelectDeviceMonitoringFilters = '[DeviceMonitoringFilter] Select DeviceMonitoringFilters',
}

export class LoadDeviceMonitoringFilters implements Action {
  readonly type = DeviceMonitoringFilterActionTypes.LoadDeviceMonitoringFilters;
}

export class SelectDeviceMonitoringFilters implements Action {
  readonly type = DeviceMonitoringFilterActionTypes.SelectDeviceMonitoringFilters;
  constructor(public payload: DeviceMonitoringFilter) {}
}


export type DeviceMonitoringFilterActions = LoadDeviceMonitoringFilters
  | SelectDeviceMonitoringFilters;
